module.exports = __webpack_public_path__ + "img/remark1.77fb03a2.png";